import React from "react"
import ReactDOM from "react-dom"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import store from "./redux/store"
import App from "./App"
import "assets/css/cssReset.css"
import "assets/css/bootstrapGrid.min.css"

store.subscribe(() => {
	console.log(store.getState())
})

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
)

serviceWorker.unregister()
